<span class="opac-icon" [attr.aria-hidden]="ariaHidden" [innerHtml]="iconSvg | safe: 'html'"></span>
